import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button/Button';
import GenericCard from '../../../components/GenericCards/GenericCards';
import useMobile from '../../../hooks/useMobileHook';
import {
  openExternalLink,
} from '../../../utils/utils';
import {
  CASE_LIST_ROUTE,
  PARTICIPANT_ACCESS_ROUTE,
  DOCUMENT_SEARCH_ROUTE,
} from '../../../routes/types';

const PromoAds = ({
  transperant = false,
  coveredFamilyMembers,
  isWaived = false,
  linksData,
}: any) => {
  const isMobile = useMobile();
  const navigate = useNavigate();

  return (
    <Row className="m-0 p-0 d-flex justify-content-between">
        <div className={'col-12 col-md-4'}> 
            <GenericCard
              onClick={() => navigate(CASE_LIST_ROUTE)}
              className={'doc-upload p-5 cursor-pointer mt-10'}
              variant={'white'}>
              <div
                className={'carousel-img-container rounded-1 overflow-hidden'}>
                <img
                  className={'w-100 h-auto'}
                  src={`${process.env.PUBLIC_URL}/${'company2.png'}`}
                  alt={`${process.env.PUBLIC_URL}/${'company2.png'}`}
                />
              </div>
              <div className="mt-4 lh-xs fw-light">
                <h6 className="mb-0 text-sm-16-lg-20">Case List</h6>
              </div>
              <div className="lh-xxs fw-light text-sub1 text-light-grey-normal">
                <span>Search and review cases</span>
              </div>
            </GenericCard>
        </div>

        <div className={'col-12 col-md-4'}> 
            <GenericCard
              onClick={() => navigate(PARTICIPANT_ACCESS_ROUTE)}
              className={'doc-upload p-5 cursor-pointer mt-10'}
              variant={'white'}>
              <div
                className={'carousel-img-container rounded-1 overflow-hidden'}>
                <img
                  className={'w-100 h-auto'}
                  src={`${process.env.PUBLIC_URL}/${'company3.png'}`}
                  alt={`${process.env.PUBLIC_URL}/${'company3.png'}`}
                />
              </div>
              <div className="mt-4 lh-xs fw-light">
                <h6 className="mb-0 text-sm-16-lg-20">Participant Access</h6>
              </div>
              <div className="lh-xxs fw-light text-sub1 text-light-grey-normal">
                <span>Access the portal as a participant</span>
              </div>
            </GenericCard>
        </div>

        <div className={'col-12 col-md-4'}> 
            <GenericCard
              onClick={() => navigate(DOCUMENT_SEARCH_ROUTE)}
              className={'doc-upload p-5 cursor-pointer mt-10'}
              variant={'white'}>
              <div
                className={'carousel-img-container rounded-1 overflow-hidden'}>
                <img
                  className={'w-100 h-auto'}
                  src={`${process.env.PUBLIC_URL}/${'company4.png'}`}
                  alt={`${process.env.PUBLIC_URL}/${'company4.png'}`}
                />
              </div>
              <div className="mt-4 lh-xs fw-light">
                <h6 className="mb-0 text-sm-16-lg-20">Document Search</h6>
              </div>
              <div className="lh-xxs fw-light text-sub1 text-light-grey-normal">
                <span>Search and review documents</span>
              </div>
            </GenericCard>
        </div>
      
    </Row>
  );
};

export default PromoAds;
